import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { AmbienteSefazService } from 'src/app/services/ambiente-sefaz/ambiente-sefaz.service';

@Component({
  selector: 'app-sefaz-stripe',
  templateUrl: './sefaz-stripe.component.html',
  styleUrls: ['./sefaz-stripe.component.scss']
})
export class SefazStripeComponent implements OnInit {

  status:boolean = true;

  sub!: Subscription;

  constructor(
    private ambienteSefazService:AmbienteSefazService
  ) { }

  ngOnInit(): void {
    this.ambienteSefazService.loadStatus();
     this.sub = this.ambienteSefazService.status$.subscribe(status => {
      if(typeof(status) == 'boolean'){
        this.status = status;
      }
    })
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

}
